import {useEffect, useState} from "react";
import BridgeEditor from "./BridgeEditor";

export default function BridgeWindow({riverStation}) {
    const [bridge, setBridge] = useState('')

    useEffect(() => {
        if(!bridge && riverStation?.base_bridges?.length > 0)
            setBridge(riverStation?.base_bridges[0]?.bridge_name)
    }, [riverStation]);

    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            {
                riverStation?.base_bridges?.length > 0 && (
                    <BridgeEditor
                        windowName={'bridge-base'}
                        selectedBridge={bridge}
                        onChangeBridge={(bridge) => setBridge(bridge)}
                        data={riverStation?.base_bridges || []}
                        title={riverStation?.base_title}
                    />
                )
            }
            {
                riverStation?.cmp_bridges?.length > 0 && (
                    <BridgeEditor
                        windowName={'bridge-cmp'}
                        targetWindow={'bridge-base'}
                        selectedBridge={bridge}
                        onChangeBridge={(bridge) => setBridge(bridge)}
                        data={riverStation?.cmp_bridges || []}
                        title={riverStation?.cmp_title}
                    />
                )
            }
        </div>
    )
}